import React, { useState } from 'react';
import { constants } from '../../Constants';
import DayPickerInput, { DateUtils } from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import { requestAppt } from '../../helpers/ConstantID';

class RequestSession extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dateTimes: [{ date: '', time: '' }],
			subdomain: '',
		};
	}

	componentDidMount() {
        if (this.props.whitelabel) {
			const subDomain = this.props.whitelabel.toLowerCase();
            this.setState({
                subdomain: subDomain
            })
        }
    }
	
	render() {
		const from = new Date();
		const to = new Date();
		const modifiers = { start: from, end: to };
        const { dateTimes } = this.props;

		return (
			<React.Fragment>
				<div className="modal-info">
				<div
					className="modal-react counsellor-apt-modal zIndex1"
					id="modal"
					tabIndex={0}
					style={{ width: '518px !important', margin: '134px auto', backgroundColor: '#fff', top: '40%' }}
				>
					<span onClick={() => this.state.subdomain === 'online' ? this.props.onCloseModalB2C(false) : this.props.onCloseModal(false)} className="close-button topright">
						<i className="fa fa-times" aria-hidden="true"></i>
					</span>
					<div className="content">
						<table
							className="table borderless table-responsive w-100 d-block d-md-table"
						>
							<tbody
								className="text-center tableBody"
							>
								{ this.state.subdomain === 'online' 
									?
                                    <React.Fragment>
                                        <tr>
                                            <td colSpan={3} className="td-no-border"></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3} className="td-no-border welcome-text">
                                                <h5 className="heading-b2c">{(constants.REQUEST_COUNSELLOR).toUpperCase()}</h5>
                                            </td>
                                        </tr>
                                        <div className="swal2-content notify-content">Thank you! We are checking on the counsellor’s availability and will revert to you with an email within 48 hours.</div>

                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <tr>
                                            <td colSpan={3} className="td-no-border"></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3} className="td-no-border">
                                                <div className="swal2-title">{constants.REQUEST_COUNSELLOR}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3} className="">
                                                <div className="swal2-content">Choose your preferred timings</div>
                                            </td>
                                        </tr>

                                        {dateTimes.map((d, i) => {
                                            return (
                                                <tr>
                                                    <td colSpan={3} className="td-no-border">
                                                        <div className="displayFlex">
                                                            <div className="InputFromTo">
                                                                <DayPickerInput
                                                                    value={new Date(d.date)}
                                                                    placeholder="Start date"
                                                                    format="LL"
                                                                    formatDate={formatDate}
                                                                    parseDate={parseDate}
                                                                    id={`stardDate${i}`}
                                                                    dayPickerProps={{
                                                                        //selectedDays: [from, { from, to }],
                                                                        disabledDays: { before: new Date() },
                                                                        modifiers,
                                                                    }}
                                                                    onDayChange={this.props.onDateChange}
                                                                />
                                                            </div>
                                                            <div className="">
                                                                <div className="select-time--container">
                                                                    <select
                                                                        id={`select-time${i}`}
                                                                        style={{
                                                                            marginTop: '0px !important',
                                                                            marginLeft: '10px !important',
                                                                            width: '100%',
                                                                        }}
                                                                        key={i}
                                                                        onChange={(e) => this.props.onTimeChange(e, i)}
                                                                        value={d.time || '00:00:00'}
                                                                    >
                                                                        <option value="00:00:00">12:00 AM</option>
                                                                        <option value="01:00:00">1:00 AM</option>
                                                                        <option value="02:00:00">2:00 AM</option>
                                                                        <option value="03:00:00">3:00 AM</option>
                                                                        <option value="04:00:00">4:00 AM</option>
                                                                        <option value="05:00:00">5:00 AM</option>
                                                                        <option value="06:00:00">6:00 AM</option>
                                                                        <option value="07:00:00">7:00 AM</option>
                                                                        <option value="08:00:00">8:00 AM</option>
                                                                        <option value="09:00:00">9:00 AM</option>
                                                                        <option value="10:00:00">10:00 AM</option>
                                                                        <option value="11:00:00">11:00 AM</option>
                                                                        <option value="12:00:00">12:00 PM</option>
                                                                        <option value="13:00:00">1:00 PM</option>
                                                                        <option value="14:00:00">2:00 PM</option>
                                                                        <option value="15:00:00">3:00 PM</option>
                                                                        <option value="16:00:00">4:00 PM</option>
                                                                        <option value="17:00:00">5:00 PM</option>
                                                                        <option value="18:00:00">6:00 PM</option>
                                                                        <option value="19:00:00">7:00 PM</option>
                                                                        <option value="20:00:00">8:00 PM</option>
                                                                        <option value="21:00:00">9:00 PM</option>
                                                                        <option value="22:00:00">10:00 PM</option>
                                                                        <option value="23:00:00">11:00 PM</option>
                                                                    </select>
                                                                    <p className="pst">{ }</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        {dateTimes.length < 3 && <div onClick={() => this.props.addSchedule()} className='addSchedule'>
                                            Add another preferred time
                                        </div>}
                                        <tr>
                                            <td colSpan={3} className="td-no-border">
                                                <button
                                                    className="cancel-submit-button"
                                                    onClick={() => this.props.onCloseModal(false)}
                                                    id={requestAppt.sh_pt_cancel_bt}
                                                >
                                                    {constants.CANCEL_TXT}
                                                </button>
                                                <button
													type="button"
													className="appintment-submit-button"
													onClick={()=>this.props.submitRequest()}
													id={requestAppt.sh_pt_confirm_bt}
												>
													{constants.SUBMIT_TEXT}
												</button>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                }
							</tbody>
						</table>
					</div>
				</div>
				</div>
			</React.Fragment>
		);
	}
}

export default RequestSession;


// WEBPACK FOOTER //
// ./src/components/RequestASession/index.js